<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div v-show="Isblur" class="splash"></div>

      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0" style="background-color:unset;">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 12vw;"> پست های سازمانی</h2>

              <div class="d-flex justify-content-between">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس پست سازمانی...">
           <div class="d-flex flex-column align-items-center">
             <router-link to="/pishkhan/Organization/list" class="btn btn-primary mb-3 btn-add-org-post btn-submit-1" href="#" style="width: 15vw; margin-right: 1vw;"
                 > پست های سازمانی در شرکت های تابعه </router-link>
             <p class="btn btn-primary btn-add-org-post" href="#" style="width: 7vw; margin-right: 1vw;"
                @click="addModalMethod"> افزودن </p>
           </div>
              </div>
              <hr>
            </div>
            <div class="table-responsive mt-3">
              <div @click="addModalMethod" v-show="!all_items.length">
                اولین پست سازمانی خود را ایجاد کنید
              </div>
              <div style="overflow-y: scroll; height: 50vw;" :style="filteredItems.length < 19 ? 'height: auto;' : ''">

              <table class="table table-striped" v-show="all_items.length">
                <thead>
                <tr>
                  <th style="width: 1vw;">ردیف</th>
                  
                  <th>پست سازمانی</th>
                  <th>سطح دسترسی  </th>
                  <th style="width: 12vw;">عملیات‌ها</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])">
                  <td scope="row">{{ index + 1 }}</td>
                  
                  <td @click="showInfo(item['count'], item['o_name'], item['curator'], item['substitute'] )"
                      style="text-align: right">{{ item['name'] }}
                  </td>
                  <td>
                    {{item['type']}}
                  </td>
                  <td>
                    <router-link :to="`/job-description/${item.id}/1`">
                      <img title="شناسنامه پست سازمانی" style="margin-right: .4vw;" class="table-operations-img"
                           src="../../assets/img/id.svg" alt="id">
                    </router-link>


                   
                    <a @click.prevent="editModalMethod(item['id'])" href="#">
                      <img style="margin-right: .4vw;"
                           class="table-edit-img"
                           src="../../assets/img/pen.svg"
                           alt="edit"></a>
                    <a @click.prevent="deleteModalMethod(item['id'])" href="#">
                      <img style="margin-right: .4vw;"
                           class="table-delete-img"
                           src="../../assets/img/delete.svg"
                           alt="delete"></a>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Jobs -->

  <div v-show="addModal" dir="rtl" class="col-lg-12 modal__for_fn_two"
       style="position:absolute;  display:block; width: 40vw; right: 45%; top: 45%; transform: translateX(30%) translateY(-45%);   ">
    <div class="card card-body card-panel-box border-0" style="background-color: unset;">
      <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
      <form class="needs-validation" novalidate>

        <div class="row">

          <div class="col-lg-6 mb-3">
            <label class="form-label">پست سازمانی </label>
            <input v-model="name" class="form-control" type="text" name="" required>
            <span style="transform: translateY(-1.3vw) translateX(-16vw); width: 1vw;display: block; cursor: pointer; font-size: 0.5vw" @click="name=''">❌</span>

          </div>
          <div class="col-lg-6 mb-3">
            <label class="form-label">مافوق</label>
            <v-select class="w-100" :options="all_items" dir="rtl" v-model="parent_id" label="o_name"
                      style="width: 12vw;   border-radius: .5vw">
              <template v-slot:no-options>موردی یافت نشد</template>
            </v-select>

          </div>
        </div>
        <div class="row">
          <div class="col-6 mb-3">
            <label class="form-label">واحد سازمانی</label>
            <v-select class="w-100" :options="all_units" dir="rtl" v-model="unit" label="title"
                      style="width: 12vw;   border-radius: .5vw">
              <template v-slot:no-options>موردی یافت نشد</template>
            </v-select>
          </div>
          <div class="col-6 mb-3">
            <label class="form-label">سطح دسترسی</label>
            <select v-model="type" class="form-select">
              <option value="" disabled selected>انتخاب کنید</option>
              <option value="تهیه کننده">تهیه کننده</option>
              <option value="تایید کننده">تایید کننده</option>
              <option value="تصویب کننده">تصویب کننده</option>
            </select>
          </div>
        </div>

        <div class="col-lg-12 mb-3">
          <label for="expert">
            <input id="expert" type="checkbox" value="1" v-model="expert">
            پست سازمانی خبره است
          </label>
        </div>


        <div class="form-buttons row d-flex justify-content-center">
          <button class="btn btn-primary btn-back mx-3" @click.prevent="addModalMethod">بازگشت</button>
          <button class="btn btn-primary btn-approve" @click.prevent="submitForm">تایید</button>
        </div>

      </form>
    </div>
  </div>
  <!--  modals-->
  <div v-show="editModal" dir="rtl" class="col-lg-12 modal__for_fn_two"
       style="position:absolute;  display:block; width: 40vw; right: 45%; top: 45%; transform: translateX(30%) translateY(-45%);   ">
    <div class="card card-body card-panel-box border-0" style="background-color: unset;">
      <h2 style="font-size: 1.2vw !important;">لطفا اطلاعات کاربر را وارد نمایید</h2>
      <form class="needs-validation" novalidate>

        <div class="row">

          <div class="col-lg-6 mb-3">
            <label class="form-label">پست سازمانی </label>
            <input v-model="name" class="form-control" type="text" name="" required>
            <span style="transform: translateY(-1.3vw) translateX(-16vw); width: 1vw;display: block; cursor: pointer; font-size: 0.5vw" @click="name=''">❌</span>

          </div>
          <div class="col-lg-6 mb-3">
            <label class="form-label">مافوق</label>
            <v-select class="w-100" :options="all_items" dir="rtl" v-model="parent_id" label="o_name"
                      style="width: 12vw;   border-radius: .5vw">
              <template v-slot:no-options>موردی یافت نشد</template>
            </v-select>

          </div>
        </div>
        <div class="row">
          <div class="col-6 mb-3">
            <label class="form-label">واحد سازمانی</label>
            <v-select class="w-100" :options="all_units" dir="rtl" v-model="unit" label="title"
                      style="width: 12vw;   border-radius: .5vw">
              <template v-slot:no-options>موردی یافت نشد</template>
            </v-select>
          </div>
          <div class="col-6 mb-3">
            <label class="form-label">سطح دسترسی</label>
            <select v-model="type" class="form-select">
              <option value="" disabled selected>انتخاب کنید</option>
              <option value="تهیه کننده">تهیه کننده</option>
              <option value="تایید کننده">تایید کننده</option>
              <option value="تصویب کننده">تصویب کننده</option>
              <option value="سایر">سایر</option>
            </select>
          </div>
        </div>
        <div class="col-lg-12 mb-3">
          <label for="expert">
            <input id="expert" type="checkbox" value="1" v-model="expert" :checked="expert">
            پست سازمانی خبره است
          </label>
        </div>


        <div class="form-buttons row d-flex justify-content-center">
          <button class="btn btn-primary btn-back mx-3" @click.prevent="backModalMethodEdit">بازگشت</button>
          <button class="btn btn-primary btn-approve" @click.prevent="update(id)">تایید</button>
        </div>

      </form>
    </div>
  </div>
  <!--  modals-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_parent" style="z-index: 999999999999999">
    <div>
      <p>انتخاب مافوق</p>
      <p @click="select_parent=!select_parent">❌</p>
    </div>
    <div>
      <input v-model="search_parent" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس پست سازمانی...">
      <div style="overflow-y: scroll; height: 20vw; width: 100%;" :style="filteredParents.length < 2 ? 'height: auto;' : ''">

      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>پست سازمانی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredParents" :key="item.id">
          <td scope="row"><input v-model="parentId" type="radio" name="parent" :value="item['id']"></td>
          <td>{{ item['name'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_parentMethod">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_curator" style="z-index: 999999999999999">
    <div>
      <p>انتخاب متصدی</p>
      <p @click="select_curator=!select_curator">❌</p>
    </div>
    <div>
      <input v-model="search_curator" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد پرسنلی و نام و نام خانوادگی  ...">
        <div style="overflow-y: scroll; height: 20vw; width: 100%;" :style="filteredCurator.length < 2 ? 'height: auto;' : ''">

      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کدپرسنلی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in filteredCurator" :key="item.id">
        <tr>
          <td scope="row"><input v-model="curatorId" type="radio" name="Curator" :value="item['id']"></td>
          <td>{{ item['personal_code'] }}</td>
          <td>{{ item['fullname'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_curatorMethod">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="select_substitute" style="z-index: 999999999999999">
    <div>
      <p>انتخاب جانشین</p>
      <p @click="select_substitute=!select_substitute">❌</p>
    </div>
    <div>
      <input v-model="search_curator" class="form-control mb-3" type="text"
             placeholder="جستجو بر اساس کد پرسنلی و نام و نام خانوادگی  ...">
        <div style="overflow-y: scroll; height: 20vw; width: 100%;" :style="filteredCurator.length < 2 ? 'height: auto;' : ''">

      <table class="table table-striped">
        <thead>
        <tr>
          <th style="width: 1vw;">انتخاب</th>
          <th>کدپرسنلی</th>
          <th>نام و نام خانوادگی</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredCurator" :key="item.id">
          <td scope="row"><input v-model="substituteId" type="radio" name="substitute" :value="item['id']"></td>
          <td>{{ item['personal_code'] }}</td>
          <td>{{ item['fullname'] }}</td>
        </tr>

        </tbody>
      </table>
      </div>
      <button @click="select_substituteMethod()">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="infoModal" style="z-index: 999999999999999">
    <div>
      <p>جزئیات</p>
      <p @click="infoModal=!infoModal">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; border-radius: 1vw; width: 28vw; padding: 1vw;">
        <div class="d-flex justify-content-evenly">
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">پست : {{ name }}</p>
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">متصدی : {{ curator }}</p>
        </div>
        <div class="d-flex justify-content-evenly">
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">جانشین : {{ substitute }}</p>
          <p style="font-size: 1.1vw ; font-weight: 500; text-align: right">تعداد زیرمجموعه: {{ count }}</p>
        </div>
      </div>

      <button @click="infoModal=!infoModal">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  /modals-->


</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
import vSelect from "vue-select";
const toast = useToast();

export default {
  name: "ListOrganization",
  components: {vSelect, Sidebar, Splash},
  data() {
    return {
      id: '',
      name: '',
      addModal: false,
      Isblur: false,
      deleteModal: false,
      select_parent: false,
      select_curator: false,
      select_substitute: false,
      editModal: false,
      infoModal: false,
      Error: false,
      ErrorM: '',
      type: '',
      searchUser: '',
      // users
      all_substitute: [],
      all_curator: [],
      all_parent: [],
      search_parent: '',
      parent_id: '',
      search_curator: '',
      search_substitute: '',
      substituteId: '',
      substituteName: '',
      curatorId: '',
      curatorName: '',
      parentName: '',
      parentId: '',
      all_items: [],
      all_units: [],
      count: 0,
      curator: '',
      substitute: '',
      expert: false,
      unit: '',
    }
  },
  methods: {
    fetchUsers2() {
      this.all_curator.length = 0
      this.all_substitute.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                if (this.curatorId !== item.id){
                  this.all_substitute.push(item)

                }


              })

            }

          })
          .catch();
    },
    resetCurator3(){
      this.parentName=''
      this.parentId=''
    },   resetCurator2(){
      this.substituteName=''
      this.substituteId=''
    },
    resetCurator(){
      this.curatorId=''
      this.curatorName=''
    },
    backModalMethodEdit() {
      this.editModal = !this.editModal
      this.Isblur = !this.Isblur
    },
    allUnits(){
      fetch(`${this.base_url}/OrganizationUnits`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
          .then(response => response.json())
          .then((response) => {
            this.all_units.length = 0
            this.all_units = response.all
          }).catch((err) => {
        console.log(err)
      })
    },
    addModalMethod() {
      this.resetForm()
      this.allUnits()
      this.addModal = !this.addModal
      this.Isblur = !this.Isblur
    },
    showInfo(count, title, curator, substitute) {
      this.infoModal = true
      this.count = count
      this.name = title
      this.curator = curator
      this.substitute = substitute

    },
    nextTree(id, newId) {
      if (newId) {

        fetch(`${this.base_url}/organization/post/change_tree/${id}/to/${newId}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
        })
            .then(response => response.json())
            .then((response) => {
              console.log(response)
              this.all_items.length = 0
              this.fetchAll()
            }).catch((err) => {
          console.log(err)
        })
      }


    },
    previousTree(id, newId) {
      if (newId) {
        if (id > newId) {

          fetch(`${this.base_url}/organization/post/change_tree/${newId}/to/${id}`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${this.$cookies.get('token')}`,
              'Content-type': 'application/json; charset=UTF-8',
            },
          })
              .then(response => response.json())
              .then((response) => {
                this.all_items.length = 0
                this.fetchAll()
              }).catch((err) => {
          })
        } else {
          fetch(`${this.base_url}/organization/post/change_tree/${id}/to/${newId}`, {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${this.$cookies.get('token')}`,
              'Content-type': 'application/json; charset=UTF-8',
            },
          })
              .then(response => response.json())
              .then((response) => {
                this.all_items.length = 0
                this.fetchAll()
              }).catch((err) => {
          })
        }
      }
    },
    editModalMethod(id) {
      this.id = id
      this.editModal = true
      this.Isblur = !this.Isblur
      this.substituteId = ''
      this.curatorId = ''
      this.parentId = ''
      this.allUnits()


      fetch(`${this.base_url}/organization/post/edit/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
      })
          .then(response => response.json())
          .then((response) =>  {
            if (response.item){
               const  item = response.item
              this.parentId = item.parent_id ? item.parent_id : ''
              this.name = item.name
              this.type = item.type
              this.expert = item.expert
              this.unit = item.unit
            }

          }).catch((err) => {
      })

    },
    deleteModalMethod(id) {
      this.id = id
      this.deleteModal = true
    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
            }
            this.deleteModal = false
            this.all_items.length = 0
            this.fetchAll()

          })
          .catch();
    },
    setcolor(level) {

      if (level === 0) {
        return `background: #86D1FF !important`

      }


      if (level === 1) {
        return 'background: #bce6ff !important'

      }
      if (level === 2) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },
    submitForm() {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.ErrorM = 'عنوان پست سازمانی اجباری است!'
          toast.error(this.ErrorM )

          this.loading = false

          return;
        } else if (!this.type) {
          this.ErrorM = 'سطح دسترسی اجباری است!'
          toast.error(this.ErrorM )

          return;
        }


        fetch(`${this.base_url}/organization/post/store`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'parent_id': this.parent_id ? this.parent_id.id : null,
            'type': this.type,
            'unit_id': this.unit ? this.unit.code:null,
            'expert': this.expert,



          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.error(response['error'])

                return
              }

              this.loading = false
              this.Isblur = !this.Isblur
              this.addModal = !this.addModal
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()
              toast.success('با موفقیت اضافه شد.')



            }).catch((err) => {
        })


      }, 1000)
    },
    update(id) {
      setTimeout(() => {
        if (this.name.length === 0) {
          this.ErrorM = 'عنوان پست سازمانی اجباری است!'
          toast.error(this.ErrorM )

          this.loading = false

          return;
        } else if (!this.type) {
          this.ErrorM = 'سطح دسترسی اجباری است!'
          toast.error(this.ErrorM )

          return;
        }


        fetch(`${this.base_url}/organization/post/update/${id}`, {
          method: 'POST',
          headers: {
            "Authorization": `Bearer ${this.$cookies.get('token')}`,
            'Content-type': 'application/json; charset=UTF-8',
          },
          body: JSON.stringify({
            'name': this.name,
            'type': this.type,
            'expert': this.expert,
            'unit_id': this.unit ? this.unit.code:null,
            'parent_id': this.parent_id ? this.parent_id.id : null,


          }),
        })
            .then(response => response.json())
            .then((response) => {
              if (response['error']) {
                toast.error(response['error'])


                this.loading = false
                return
              }

              this.loading = false
              this.Isblur = !this.Isblur
              this.editModal = !this.editModal
              this.all_items.length = 0
              this.fetchAll()
              this.resetForm()
              toast.success('با موفقیت ویرایش شد.')


            }).catch((err) => {
        })


      }, 1000)
    },
    resetForm() {
      this.name = ''
      this.substituteName = ''
      this.curatorName = ''
      this.parentName = ''
      this.type = ''
      this.parentId = ''
      this.unit = ''
      this.expert = 0
      this.parent_id = ''
    },
    select_substituteMethod() {
      this.select_substitute = !this.select_substitute
      this.all_curator.forEach((item) => {
        this.substituteId === item.id ? this.substituteName = item.fullname : ''

      })
    },
    select_curatorMethod() {
      this.select_curator = !this.select_curator
      this.all_curator.forEach((item) => {
        this.curatorId === item.id ? this.curatorName = item.fullname : ''


      })
    },
    select_parentMethod() {
      this.select_parent = !this.select_parent
      this.all_parent.forEach((item) => {
        this.parentId === item.id ? this.parentName = item.name : ''

      })

    },


    select_parentModal() {
      this.fetchParents()
      this.select_parent = true
    },

    select_curatorModal() {
      this.fetchUsers()
      this.select_curator = true
      this.search_curator = ''

    },
    select_substituteModal() {
      this.fetchUsers2()
      this.select_substitute = true
      this.search_curator = ''

    },
    fetchUsers() {
      this.all_curator.length = 0
      this.all_substitute.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['users'].length !== 0) {
              result['users'].forEach(item => {
                this.all_substitute.push(item)
                this.all_curator.push(item)

              })

            }

          })
          .catch();
    },
    fetchParents() {
      this.all_parent.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_parent.push(item)

              })

            }

          })
          .catch();
    },
    fetchAll() {
      this.all_parent.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/organization/post/all_tree`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result['all'].length !== 0) {
              result['all'].forEach(item => {
                this.all_items.push(item)

              })

            }

          })
          .catch();
    },
    checkIsMother(){
      if (!this.is_mother){
        router.push('/pishkhan')
      }

    }
  },
  mounted() {
    this.fetchAll()
    this.checkIsMother()
  },
  computed: {
    filteredParents() {
      return this.all_parent.filter(item => {
        return (
            item['name']&& item['name'].includes(this.search_parent)
        );
      });
    },
    filteredCurator() {
      return this.all_curator.filter(item => {
        return (

            item['fullname']&& item['fullname'].includes(this.search_curator)
        );
      });
    },
    filteredItems() {
      return this.all_items.filter(item => {
        return (
            item['fullname']&&   item['name'].includes(this.searchUser) || item['id'].toString().includes(this.searchUser)
        );
      });
    },

  },
}
</script>

<style scoped>
label {
  width: 100%;
  text-align: right;
}

table {
  background-color: white !important;
}


img {
  cursor: pointer;
}

tr {
  background-color: #ffff !important;
}

</style>